// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"4892eb78","241":"4970c035","342":"2830e25d","453":"6f5e9d2d","526":"284988ab","578":"578acdb7","642":"6d073b40"}[chunkId] + ".chunk.js";
};